import { executeRequest, JFSRequest } from '@jfs/network'
import { convertToCaps } from '../utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const keys = Object.keys(data)
  return keys?.map((key) => {
    return {
      id: key,
      value: convertToCaps(data[key] ?? ''),
    }
  })
}

const getGroupIds = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGroupIdName),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getGroupIds }
